<template>
  <!-- Аватар человека: фото или первая буква имени на сером круге -->
  <img
    v-if="src"
    class="support-avatar"
    :src="src"
    :srcset="srcset"
    :width="size"
    :height="size"
    :style="box"
    alt=""
  >
  <span v-else class="support-avatar support-avatar--letter" :style="box">{{ letter }}</span>
</template>

<script>
  export default {
    name: 'SupportAvatar',
    props: {
      src: { type: String, default: null },
      srcset: { type: String, default: null },
      name: { type: String, default: '' },
      size: { type: Number, default: 40 },
    },
    computed: {
      letter () {
        return (this.name || '?').trim().charAt(0).toUpperCase()
      },
      box () {
        return { width: `${this.size}px`, height: `${this.size}px`, fontSize: `${Math.round(this.size * 0.42)}px` }
      },
    },
  }
</script>

<style scoped lang="less">
@import './tokens.less';

.support-avatar {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  object-fit: cover;

  &--letter {
    font-weight: 500;
    color: @fakt-text-2;
    background: @fakt-surface;
  }
}
</style>
